import { render, staticRenderFns } from "./SearchSelectTag.vue?vue&type=template&id=1187f500&scoped=true&"
import script from "./SearchSelectTag.vue?vue&type=script&lang=js&"
export * from "./SearchSelectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1187f500",
  null
  
)

export default component.exports